import styled from 'react-emotion';

export const Container = styled('div')`
  outline: none;
`;
